import './cookie.scss';

/**
 * version    1.0
 * class      <type> (Cookie)
 */
export class Cookie {}
